<div [ngClass]="[headerClasses]" routerLinkActive="active">
  <div (click)="getHome()">
    <img src="assets/icons/svg/weBuy.svg" class="h-12">
  </div>
  <div>
    <app-menu></app-menu>
  </div>
</div>
